// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__30EUp","inputWrap":"Table_inputWrap__C2vsa","col":"Table_col__32O2V","bmiTooltip":"Table_bmiTooltip__1cptG"};